export default "__VITE_ASSET__ituWW4Kk__"